<template>
  <div class="body">
    <iframe v-show="showType === 'iframe'" src="" frameborder="0" id='iframe' width='100%' height='100%'></iframe>
    <!-- <vue-office-docx
      v-show="showType === 'doc'"
      :src="docUrl"
      style="height: 50vh;"
    /> -->
  </div>
</template>

<script>
// 引入VueOfficeDocx组件
// import VueOfficeDocx from '@vue-office/docx';
// 引入相关样式
// import '@vue-office/docx/lib/index.css';
export default {
//   components: {VueOfficeDocx},
  data () {
    return {
      showType: '',
      docUrl: ''
    }
  },
  methods: {
    open (url) {
      this.$nextTick(() => {
        this.showType = 'iframe'
        if (url.indexOf('.pdf') > -1) {
          // document.getElementById('iframe').src = url + '#toolbar=0'
          document.getElementById('iframe').src = url
        } else if (url.indexOf('.pptx') > -1) {
          let resultNew = encodeURIComponent(url)
          document.getElementById('iframe').src = `https://view.officeapps.live.com/op/view.aspx?src=${resultNew}`
          // document.getElementById('iframe').src = `${window.location.origin}${window.location.pathname}/pptx/index.html?src=${url}`
          // console.log(`${window.location.origin}${window.location.pathname}`, '---')
        } else if (url.indexOf('.docx') > -1) {
          this.showType = 'doc'
          this.docUrl = url
        } else {
          let resultNew = encodeURIComponent(url)
          document.getElementById('iframe').src = `https://view.officeapps.live.com/op/view.aspx?src=${resultNew}`
        }
      })
    }
  }
}
</script>
<style scoped>
.body {
  height: calc(100% - 100px);
}
</style>



// WEBPACK FOOTER //
// src/components/Iframe/index.vue